export type GrowSectionChecklistItem = {
  id: string
  caption: string
}

export const GROW_SECTION_CHECKLIST_ITEMS: GrowSectionChecklistItem[] = [
  {
    id: 'GrowSectionChecklistItem-001',
    caption: 'Facilitated introductions to members',
  },
  {
    id: 'GrowSectionChecklistItem-002',
    caption: 'A close-knit business network',
  },
  {
    id: 'GrowSectionChecklistItem-003',
    caption: 'A relaxed networking environment',
  },
  {
    id: 'GrowSectionChecklistItem-004',
    caption: 'Industry leader speaking events',
  },
  {
    id: 'GrowSectionChecklistItem-005',
    caption: 'Freedom to connect at your own pace',
  },
  {
    id: 'GrowSectionChecklistItem-006',
    caption: 'Industry Relationships that last a lifetime speaking events',
  },
]
